import {HttpRequest} from '../../../settings/HttpRequest/HttpRequest';

export const ComoTeEnterasteService = {
	Listar: () => {
		let params = {};
		return new Promise((resolve, reject) => {
			HttpRequest.post('_Cat/_Como_Te_Enteraste_Datos', params).then((response) => {
				resolve(response);
			}).catch((error) => {
				reject(error);
			});
		});
	},
	Agregar: (form) => {
		let params = {
			como_te_enteraste: form.como_te_enteraste,
			activo: form.activo ? 1 : 0
		};
		return new Promise((resolve, reject) => {
			HttpRequest.post('_Cat/_Como_Te_Enteraste_Guardar', params).then((response) => {
				resolve(response);
			}).catch((error) => {
				reject(error);
			});
		});
	},
	Modificar: (form) => {
		let params = {
			id_cat_como_te_enteraste: form.id_cat_como_te_enteraste,
			como_te_enteraste: form.como_te_enteraste,
			activo: form.activo ? 1 : 0
		};
		return new Promise((resolve, reject) => {
			HttpRequest.post('_Cat/_Como_Te_Enteraste_Modificar', params).then((response) => {
				resolve(response);
			}).catch((error) => {
				reject(error);
			});
		});
	},
	Eliminar: (id_cat_como_te_enteraste) => {
		let params = {
			id_cat_como_te_enteraste: id_cat_como_te_enteraste
		};
		return new Promise((resolve, reject) => {
			HttpRequest.post('_Cat/_Como_Te_Enteraste_Eliminar', params).then((response) => {
				resolve(response);
			}).catch((error) => {
				reject(error);
			});
		});
	}
};
